// extracted by mini-css-extract-plugin
export default {"price":"TZ-z","onSale":"UZ-z","msrpLabelPrice":"VZ-z","originalPrice":"WZ-z","msrpLabel":"XZ-z","percentOff":"YZ-z"};